import React, { useEffect } from 'react';
import styled from 'styled-components';
import Footer from './Footer';
import { colors } from '../styles/colors';
import Navigation from './Navigation';

const FullScreenContainer = styled.div`
  width: 100vw;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  overflow-x: hidden;
  overscroll-behavior-x: none;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${colors.neutral.black};
`;

const HeaderSection = styled.div`
  width: 100%;
  min-height: 120px;
  background-color: ${colors.neutral.darkBrown};
  background-size: 
    2px 2px, 3px 3px, 1px 1px, 4px 4px, 5px 5px, 6px 6px, 
    2px 2px, 7px 7px, 1px 1px, 8px 8px, 2px 2px, 3px 3px;
  background-position: 
    0 0, 1px 1px, 2px 2px, 3px 3px, 4px 4px, 5px 5px,
    6px 6px, 7px 7px, 8px 8px, 9px 9px, 10px 10px, 11px 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    min-height: 280px;
    padding: 30px 20px;
  }

  @media (max-width: 480px) {
    min-height: 240px;
    padding: 25px 15px;
  }
`;

const PageTitle = styled.h1`
  font-family: 'saint-andrews-queen', cursive;
  font-size: clamp(7rem, 10vw, 8rem);
  color: ${colors.primary.gold};
  text-align: center;
  padding-top: 100px;
  margin: 0;
  letter-spacing: 2px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: clamp(4rem, 8vw, 6rem);
  }

  @media (max-width: 480px) {
    font-size: clamp(3rem, 6vw, 4.5rem);
  }
`;

const MountainBottom = styled.div`
  position: relative;
  width: 100vw;
  height: auto;
  z-index: 10;
  margin-top: -1px;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  background: linear-gradient(
    to bottom,
    ${colors.neutral.darkBrown} 0 2px,
    ${colors.primary.lightTan} 2px 100%
  );
  overflow: hidden;
  
  img {
    width: 100%;
    height: auto;
    display: block;
    min-height: 80px;
    position: relative;
    top: -1px;
    margin-bottom: -1px;
    transform: scaleY(-1) scaleX(1.1); /* Flip upside down and scale 10% wider */
  }

  @media (max-width: 768px) {
    img {
      min-height: 60px;
      transform: scaleY(-1) scaleX(1.1);
    }
  }

  @media (max-width: 480px) {
    img {
      min-height: 40px;
      transform: scaleY(-1) scaleX(1.1);
    }
  }
`;

const ContentSection = styled.section`
  width: 100%;
  background-color: ${colors.primary.lightTan};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 30;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 40px 15px;
  }

  @media (max-width: 480px) {
    padding: 30px 10px;
  }
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
  min-height: 400px;
`;

const HappyCactusImage = styled.img`
  width: 150px;
  height: auto;
  margin-bottom: 2rem;
  
  @media (max-width: 480px) {
    width: 150px;
    margin-bottom: 1.5rem;
  }
`;

const MessageText = styled.p`
  font-family: 'GremeryTwo', cursive;
  font-size: 1.5rem;
  color: ${colors.neutral.darkBrown};
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.1rem;
  }
`;

const RegistryDetails: React.FC = () => {
  // Fix for mobile Safari viewport height
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH();
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);

    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
    };
  }, []);

  return (
    <FullScreenContainer>
      <HeaderSection>
        <Navigation />
        <PageTitle>Registry</PageTitle>
      </HeaderSection>
      
      <MountainBottom>
        <img src="/images/mountains/mountain-soft-top.svg" alt="Mountain Bottom" />
      </MountainBottom>

      <ContentSection>
        <MessageContainer>
          <HappyCactusImage 
            src="/images/svgs/happy-cactus.svg" 
            alt="Happy Cactus" 
          />
          <MessageText>Registry coming soon...</MessageText>
        </MessageContainer>
      </ContentSection>

      <Footer />
    </FullScreenContainer>
  );
};

export default RegistryDetails;
